import model from './model';
import RelayLogDetailsPage from './pages/RelayLogDetailsPage';

model.routes.setRoutes({
  detailsRoute: {
    component: RelayLogDetailsPage,
  },
});
